"use strict";
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontMetrics = void 0;
/**
 *
 *
 */
class FontMetrics {
    _fontRenderContext;
    _font;
    constructor(font) {
        //_fontRenderContext=new FontRenderContext();
        this._font = font;
    }
    stringWidth(str) {
        return this._font.getSize() / 2 * str.length;
    }
    getFontRenderContext() {
        return this._fontRenderContext;
    }
}
exports.FontMetrics = FontMetrics;
//# sourceMappingURL=FontMetrics.js.map